(function() {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3ClubAdmin', {
            templateUrl: 'app/club-admin/club-admin.component.html',
            controller: ClubAdminComponent,
            bindings: { club: '<' }
        });

    ClubAdminComponent.$inject = ['user'];
    function ClubAdminComponent(user) {
        var ctrl = this;

        ctrl.isAssociationAdmin = user.isAssociationAdmin;
        ctrl.isLimitedClubAdmin = user.isLimitedClubAdmin;
        ctrl.isHandicapChair = user.isHandicapChair;        
    }
})();